import { MenuItem, Stack, styled } from '@mui/material';
import { dataGridBorderColor } from 'themes/colors';

export const StyledSelectOption = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== 'hasBottomBorder',
})<{
  hasBottomBorder?: boolean;
}>`
  padding-top: 8px;
  padding-bottom: 8px;
  font-weight: 500;
  border-bottom: ${({ hasBottomBorder }) => (hasBottomBorder ? `1px solid ${dataGridBorderColor}` : '')};

  & .MuiTypography-root {
    font-weight: 500;
  }
`;

export const StyledMenuItemIconHolder = styled(Stack)`
  max-width: 24px;
  width: 24px;
  height: 24px;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  & > img {
    margin: auto;
    object-fit: contain;
    object-position: center;
  }
`;
